import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { useTranslate } from 'react-polyglot';

import './Dashboard.scss';

import { findRedirect } from "../../Shared/OrgRoles/OrgRoles"


function Dashboard(props) {
    const history = useHistory();
    const t = useTranslate();

    useEffect(() => {
        if (localStorage.getItem("user") != null && JSON.parse(localStorage.getItem("user") as string)["userdata"]["unit"][0] != "") {
            const localStorageUser = JSON.parse(localStorage.getItem("user") as string);
            if (localStorageUser["userdata"]["role"][0] !== "Admin") {
                history.push(findRedirect(localStorageUser["userdata"]["orgRole"][0]))
            } else {
                history.push("/resourcebooking")
            }
        }
    }, []);


    return (
        <div className="maincontent">
            <div className="dashboard-container">
                <div className="pagetitle-container">
                    <h1>{t("dashboard.pagetitle")}</h1>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;